import Link from "next/link";

const appConfig = {
  persistJWT: "Hamrah",
  sideMenu: {
    admin: [
      {
        label: "داشبورد",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        key: "/dashboard",
        component: "",
      },
      {
        label: "ژانر",
        key: "/genre",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "دسته‌بندی",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
        children: [
          {
            key: "/category/main",
            label: "اصلی",
          },
          // {
          //   key: "/category/specials",
          //   label: "ویژه",
          // },
          {
            key: "/category/artists",
            label: "هنرمندان",
          },
          {
            key: "/category/tag",
            label: "تگ",
          },
          {
            key: "/category/ages",
            label: "رده سنی",
          },
        ],
      },
      {
        label: (
          <Link href="/content-information" className="text-[#F5F5F5]">
            اطلاعات محتوا
          </Link>
        ),
        key: "/content-information",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
        children: [
          {
            key: "/content-information/film",
            label: "فیلم",
          },
          {
            key: "/content-information/series",
            label: "سریال",
          },
          {
            key: "/content-information/program",
            label: "برنامه",
          },
          {
            key: "/content-information/live",
            label: "پخش زنده",
          },
        ],
      },
      {
        label: "آناوطن",
        key: "/ana-vatan",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "اشتراک‌ها",
        key: "/subscriptions",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "مالی",
        key: "/financial",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
        children: [
          {
            key: "/financial/transactions",
            label: "تراکنش‌ها",
          },
          {
            key: "/financial/token",
            label: "ژتون",
          },
          {
            key: "/financial/discount-code",
            label: "کد تخفیف",
          },
        ],
      },
      {
        label: "کاربران",
        key: "/users",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "صفحات",
        key: "/cms-pages",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "دیدگاه‌ها",
        key: "/views",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "پلتفرم ویدئویی",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "/video-platform",

        children: [
          {
            key: "/video-platform/videos-list",
            label: "لیست ویدئوها",
          },
          {
            key: "/video-platform/audio-list",
            label: "لیست صوت",
          },
          {
            key: "/video-platform/watermark",
            label: "واترمارک",
          },
          {
            key: "/video-platform/media-reports",
            label: "گزارشات مدیا",
          },
          {
            key: "/video-platform/channels",
            label: "کانال ها",
            children: [
              {
                key: "/video-platform/channels/film",
                label: "فیلم",
              },
              {
                key: "/video-platform/channels/series",
                label: "سریال",
              },
              {
                key: "/video-platform/channels/program",
                label: "برنامه",
              },
              {
                key: "/video-platform/channels/music",
                label: "موسیقی",
              },
              {
                key: "/video-platform/channels/live-streaming",
                label: "پخش‌زنده",
              },
              {
                key: "/video-platform/channels/profiles",
                label: "پروفایل‌ها",
              },
            ],
          },
          {
            key: "/video-platform/player",
            label: "پلیر",
          },
        ],
      },
      {
        label: "سطل آشغال",
        key: "/garbage",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "لینک‌کوتاه",
        key: "/link",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "کارتابل",
        key: "/cartable",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "صف ترنس‌کد",
        key: "/trans-code-queue",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "محتوای ترنس‌کد شده",
        key: "/dashboard/transcoded-content",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "آگهی‌ها",
        key: "/advertising",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",

        children: [
          {
            key: "/advertising/content",
            label: "براساس محتوا",
          },
          {
            key: "/advertising/campaign",
            label: "براساس کمپین آگهی",
          },
          {
            key: "/advertising/teaser-archive",
            label: "آرشیو تیزر",
          },
          {
            key: "/advertising/report",
            label: "گزارش آگهی‌ها",
          },
        ],
      },
      {
        label: "همکاران",
        key: "/colleagues",

        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
      {
        label: "تنظیمات",
        key: "/dashboard/profile",
        icon: (
          <img src="/images/icon-sidebar.svg" alt="" width={25} height={25} />
        ),
        component: "",
      },
    ],
  },
  DEPLOY_URL:
    process.env.DEPLOY_URL || "",
};

export default appConfig;
